<template>
  <div class="bg-brand flex xs-grid-cols-1 inline gap-3 vertical">
    <h1 class="f0 text-bold text-center" v-html="title"></h1>
    <div class="static-welcome-search__search" v-if="searchType !== '' && !glb.rentals && glb.pageType != 'vsitemap_states'">
      <mvtAutocomplete
          :otherPages="'ST'"
          ref="autocomplete1"
          inputRefName="input1"
          id="textboxGeo1"
          :classname="'large'"
          :placeholder="getPlaceHolderText"
          :options="getAutoCompleteOpt"
          v-model="searchInfo"
          btnclass=""
      />
    </div>
  </div>
</template>

<script src="./static-welcome-search.js"></script>
<style lang="scss">
@use "./static-welcome-search.scss" as *;
</style>